import { ComponentProps, styled } from "@givenwell/stitches";
import { ReactNode } from "react";

export const Root = styled("div", {
  flex: "1 0 0px",
  display: "flex",
  flexDirection: "column",

  "--bottom-nav-height": "62px",
  "--bottom-inset-including-nav":
    "calc(max(var(--safe-area-inset-bottom), 28px) - 12px + var(--bottom-nav-height) + var(--layout-margin))",
  "@xs": {
    "--bottom-nav-height": "52px",
  },
  "@sm": {
    "--bottom-nav-height": "44px",
  },
  "@lg": {
    "--bottom-inset-including-nav": "var(--safe-area-inset-bottom)",
  },
  paddingTop: "max(var(--safe-area-inset-top), var(--layout-margin))",
  paddingBottom: "max(var(--bottom-inset-including-nav), var(--layout-margin))",

  variants: {
    hasTopAppBar: {
      true: {
        paddingTop: "calc(var(--safe-area-inset-top) + 56px)",
        "@lg": {
          paddingTop: "max(var(--safe-area-inset-top), var(--layout-margin))",
        },
      },
    },
  },
});

export type PageWrapperProps = ComponentProps<typeof Root> & { topAppBar?: ReactNode };

export function PageWrapper({ topAppBar, children, ...props }: PageWrapperProps) {
  return (
    <Root {...props} hasTopAppBar={!!topAppBar}>
      {topAppBar}
      {children}
    </Root>
  );
}
